// extracted by mini-css-extract-plugin
export var parcelRow = "_tf-0";